import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { LxImgNotFound } from "../..";

function Label() {
  return (
    <Typography variant="h2" sx={{ mt: 15, mb: 15 }}>
      Ups! Diese Seite wurde nicht gefunden!
    </Typography>
  );
}

function DashboardButton() {
  return (
    <Button
      sx={{ mt: 15 }}
      variant="contained"
      color="primary"
      component="a"
      href="/dashboard"
    >
      Zum Dashboard
    </Button>
  );
}

/**
 * 
 * `LxPageNotFound` provides a default 404 view.
 * 
 * Use it in your `AppRoute` to set up a _catch-all_ route:
 * 
 * https://www.figma.com/file/ygNBVsxpO4e7hralWAi6mO/CatchAllRoute
 * @package Pages
 * @noapi
 * @example
import { LxPageNotFound } from "@lxo-blocks/react";

export function AppRoute() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        // .. Catch all route
        <Route path="*">
          <LxPageNotFound />
        </Route>
      </Switch>
    </Router>
  );
}
 */
export function LxPageNotFound() {
  return (
    <Grid container direction="column" alignItems="center">
      <Label />
      <LxImgNotFound />
      <DashboardButton />
    </Grid>
  );
}
